import React, { KeyboardEvent } from "react";

export default function TickerSearch({
                                         inputTicker,
                                         setInputTicker,
                                         setTicker,
                                         setTickerQueried,
                                         tickerError,
                                         setTickerError,
                                         setPageError,
                                         onSearchApplyPeriod, // NEW
                                     }: {
    inputTicker: string;
    setInputTicker: (s: string) => void;
    setTicker: (s: string) => void;
    setTickerQueried: (b: boolean) => void;
    tickerError: string | null;
    setTickerError: (s: string | null) => void;
    setPageError: (s: string | null) => void;
    onSearchApplyPeriod?: () => void;      // NEW
}) {
    const runSearch = () => {
        const t = (inputTicker || "").trim().toUpperCase();
        if (!t) {
            setTickerError("Enter a ticker to search.");
            return;
        }
        setTickerError(null);
        setPageError(null);
        setTicker(t);
        setTickerQueried(true);
        onSearchApplyPeriod?.(); // apply the pending period when searching (ticker mode)
    };

    const onKey = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") runSearch();
    };

    return (
        <div style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", gap: 8 }}>
                <input
                    value={inputTicker}
                    onChange={(e) => setInputTicker(e.target.value)}
                    onKeyDown={onKey}
                    placeholder="NVDA"
                    style={{
                        flex: "0 0 280px",
                        padding: "10px 12px",
                        background: "#202020",
                        color: "#fff",
                        border: "1px solid #555",
                        borderRadius: 6,
                        fontSize: 14,
                    }}
                />
                <button
                    onClick={runSearch}
                    style={{
                        padding: "10px 16px",
                        background: "#2b2b2b",
                        color: "#fff",
                        border: "1px solid #666",
                        borderRadius: 6,
                        cursor: "pointer",
                        fontWeight: 700,
                    }}
                >
                    Search
                </button>
            </div>
            {tickerError && (
                <div style={{ marginTop: 6, color: "#ffbcbc" }}>
                    {tickerError}
                </div>
            )}
        </div>
    );
}
